import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROUTES_CONFIG } from '../config/routes-permissions';

function ProtectedRoute() {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // 保存用戶要去的頁面，登入後可以重導向回去
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 檢查當前路徑是否在配置中
  const currentPath = Object.keys(ROUTES_CONFIG).find(path => {
    // 將路徑參數替換為實際值進行比對
    const pathRegex = new RegExp(
      '^' + path.replace(/:[^\s/]+/g, '([^/]+)') + '$'
    );
    return pathRegex.test(location.pathname);
  });

  if (!currentPath) {
    // 如果路徑不在配置中，允許訪問（或者可以選擇重定向到 404 頁面）
    return <Outlet />;
  }

  // 檢查用戶角色是否有權限訪問
  const hasPermission = ROUTES_CONFIG[currentPath].roles.some(role => 
    user.roles.includes(role)
  );

  if (!hasPermission) {
    // 可以重定向到一個"無權限"頁面
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;